import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextField } from 'edenred-ui';

import {
  createRules,
  FormFields,
  useOnBlurTrim,
  withFormNameContext
} from '@epi-forms/helpers';
import {
  firstName,
  maxLength,
  required
} from '@epi-helpers/formHelpers/validators';
import { FirstNameFieldProps } from '@epi-models/forms/Controls';

export function FirstNameField({
  disabled = false,
  context = '',
  readOnly = false
}: FirstNameFieldProps) {
  const name = withFormNameContext(context, FormFields.FirstName);
  const { control } = useFormContext();
  const { t } = useTranslation();
  const onBlurTrim = useOnBlurTrim(name);
  const validators = [required, maxLength(31), firstName];
  const rules = createRules(validators);

  const {
    field: { ref, value, onChange: setValue },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  return (
    <TextField
      label={t('controls.first_name_label')}
      required
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      fullWidth
      id={name}
      error={!!error}
      helperText={error?.message}
      inputRef={ref}
      onBlur={onBlurTrim}
      onChange={setValue}
    />
  );
}
